import { render } from "./checkout.view.vue?vue&type=template&id=635c332f&scoped=true&ts=true"
import script from "./checkout.view.vue?vue&type=script&lang=ts"
export * from "./checkout.view.vue?vue&type=script&lang=ts"

import "./checkout.view.vue?vue&type=style&index=0&id=635c332f&lang=scss&scoped=true"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635c332f"]])

export default __exports__